import { TextField } from '@cinesend/ui-kit'
import { useState } from 'react'
import { DISABLED_REASONS } from '../../constants/disabled_reasons'
import DisabledTooltip from '../disabled_tooltip'

const Identifier = ({ field, saveField }) => {
  const [name, setName] = useState(field.name)
  const isLocked = field?.uneditable_when_locked_attributes?.includes('name') ?? false
  return (
    <DisabledTooltip reason={isLocked ? DISABLED_REASONS.schemaLocked : null} className='block w-full'>
      <TextField
        label='Field identifier'
        value={name}
        onChange={(e) => setName(e.target.value)}
        onBlur={() => saveField({ name })}
        disabled={isLocked}
      />
    </DisabledTooltip>
  )
}

export default Identifier
